/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_RolesInputs */

const cs_clients_filter_roles = /** @type {(inputs: Clients_Filter_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const en_clients_filter_roles = /** @type {(inputs: Clients_Filter_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Clients_Filter_RolesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_roles = /** @type {((inputs?: Clients_Filter_RolesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_RolesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_roles(inputs)
	return cs_clients_filter_roles(inputs)
});